import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import {
  Popup,
  Form
} from 'semantic-ui-react'

import {
  notNilOrEmpty
} from '_utils'

const getMomentValue = R.ifElse(
  x => moment(x).isValid(),
  x => moment(x),
  R.always(moment())
)

const BaseDateField = ({
  name,
  width,
  value,
  minDate,
  maxDate,
  onChange,
  popupTxt,
  labelTxt
}) => {
  return (
    <Form.Field width={R.isNil(width) ? null : width} >
      { notNilOrEmpty(popupTxt) && notNilOrEmpty(labelTxt)
        ? <Popup
          trigger={<label>{labelTxt}</label>}
          content={popupTxt}
        />
        : notNilOrEmpty(labelTxt)
          ? <label>{labelTxt}</label>
          : null
      }
      <DatePicker
        selected={value ? getMomentValue(value) : null}
        onChange={date => onChange({}, {name, value: date})}
        onChangeRaw={event => onChange({}, {name, value: moment(new Date(event.target.value))})}
        minDate={ minDate ? moment(minDate) : null}
        maxDate={ maxDate ? moment(maxDate) : null}
        placeholderText="Select a date"
      />
    </Form.Field>
  );
};

BaseDateField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.instanceOf(moment),
    PropTypes.string
  ]),
  width: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  popupTxt: PropTypes.string,
  labelTxt: PropTypes.string,
  minDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.instanceOf(moment),
    PropTypes.string
  ]),
  maxDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.instanceOf(moment),
    PropTypes.string
  ])
}

export default BaseDateField



// WEBPACK FOOTER //
// ./webAdmin/forms/baseDate.js